import * as React from 'react'
import {
  Easy,
  EasyNZ,
  Freedom,
  Flexible,
  Hours,
  Money,
  Speed,
  Transparency,
} from '../../atoms/images/value-props'
import { ValueProp } from './types'
import { COUNTRY_SHORTCODES } from '../../../constants'
import { CountryCode } from '@doordash/lib-i18n'

import * as t from './strings'

export const ValuePropsList: ValueProp[] = [
  {
    title: t.props.money.title(),
    description: t.props.money.description(),
    image: <Money width={60} height={49} />,
  },
  {
    title: t.props.hours.title(),
    description: t.props.hours.description(),
    image: <Hours width={60} height={49} />,
  },
  {
    title: t.props.freedom.title(),
    description: t.props.freedom.description(),
    image: <Freedom width={60} height={49} />,
  },
  {
    title: t.props.easy.title(),
    description: t.props.easy.description(),
    image: <Easy width={60} height={49} />,
  },
  {
    title: t.props.speed.title(),
    description: t.props.speed.description(),
    image: <Speed width={60} height={49} />,
  },
  {
    title: t.props.transparency.title(),
    description: t.props.transparency.description(),
    image: <Transparency width={60} height={49} />,
  },
]

export const NZValuePropsList: ValueProp[] = [
  {
    title: t.props.easyNZ.title(),
    description: t.props.easyNZ.description(),
    image: <EasyNZ width={60} height={49} />,
  },
  {
    title: t.props.flexible.title(),
    description: t.props.flexible.description(),
    image: <Flexible width={60} height={49} />,
  },
  {
    title: t.props.flush.title(),
    description: t.props.flush.description(),
    image: <Money width={60} height={49} />,
  },
]

export const getValuePropsForCountry = (country: CountryCode): ValueProp[] => {
  switch (country) {
    case COUNTRY_SHORTCODES.NZ:
      return NZValuePropsList
    default:
      return ValuePropsList
  }
}

export const INLINE_PROPS_WIDTH = 800
